import request from '@/utils/request'

export function getmsosikip(acsbn) {
  return request({
    url: `/api/msosikip/` + acsbn,
    method: 'get',
  })
}

// export function getmsosikip(acsbn) {
//   return request({
//     url: `/api/msosikip`,
//     method: 'get',
//     params: {
//       acsbn: acsbn,
//     },
//   })
// }
